// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__UbszI","info":"Note_info__2fAHd","note":"Note_note__ty6LE","actions":"Note_actions__2XDLn"};